import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/axiosAuth";

export const fetchWholesaleUsers = createAsyncThunk(
  "api/wholesaleUsers/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`/api/WholesaleUsers`);
      return { rows: response.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const wholesaleUsersSlice = createSlice({
  name: "wholesaleUsers",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWholesaleUsers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWholesaleUsers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
      })
      .addCase(fetchWholesaleUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default wholesaleUsersSlice.reducer;
export const selectWholesaleUsersRows = (state) => state.wholesaleUsers.rows;
export const selectWholesaleUsersStatus = (state) =>
  state.wholesaleUsers.status;
export const selectWholesaleUsersError = (state) => state.wholesaleUsers.error;
